import { withPageBasic } from '@v2/pages/hoc/withPageBasic';
import { WalletScaPanel } from './panel';

export const WalletScaPage = withPageBasic(WalletScaPanel);
WalletScaPage.displayName = 'WalletScaPage';

export default WalletScaPage;
